
import VFormGroup from '~/components/ui/VFormGroup'
import VButton from '~/components/ui/VButton'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            currentDate: new Date(),
            dateStartRF24: null,
            dateEndRF24: null,
            dateLeftRF24: null,
            timer: null
        }
    },
    mounted() {
        // updated_at временное решение
        // if (this.project && this.project.status === 'finance_round_time' && this.project.updated_at) {
        //     this.dateStartRF24 = moment(this.project.updated_at);
        //     this.dateEndRF24 = moment(this.project.updated_at).add(1, 'days');
        //     const different = this.dateEndRF24.diff(moment());
        //     this.dateLeftRF24 = moment.duration(different);

        //     if (different > 0) {
        //         this.timer = setInterval(() => {
        //             if (this.dateLeftRF24._milliseconds > 0) {
        //                 this.dateLeftRF24 = this.dateLeftRF24.subtract(1, 'seconds');
        //             } else {
        //                 clearInterval(this.timer);
        //             }
        //         }, 1000)
        //     }
        // }
        this.timer = setInterval(() => {
            this.tick()
        }, 1000)
    },
    computed: {
        ...mapState('profile', [
            'currentAccount'
        ]),
        ...mapGetters('profile', [
            'role'
        ]),
        timerEndDate() {
            if (this.project.finance_round) {
                return new Date(this.project.finance_round.application_ending)
            }
            return false
        },
        timerLeftTime() {
            if (new Date() > this.timerEndDate) {
                return `00:00:00`
            } else {
                const date = this.timerEndDate - this.currentDate
                return new Date(date).toLocaleTimeString('ru-RU', { timeZone: 'Etc/UTC' }) 
            }
        },
        dateLeftRF24Format() {
            if (this.dateLeftRF24) {
                return `${this.momentGetDuration('hours')}:${this.momentGetDuration('minutes')}:${this.momentGetDuration('seconds')}`
            }
            return '00:00:00';
        },
        canExtendRound(){
            return !this.project.is_extended && (this.eightyPercent > this.project.current_sum) && this.project.status === 'finance_round_time'
        },
        canSignContract() {
            return this.project.status === 'finance_round_time' && (this.project.finance_round.sum_min <= this.project.current_sum) && (this.eightyPercent <= this.project.current_sum)
        },
        canFinishRound() {
            return this.project.status === 'finance_round' && (this.project.current_sum >= this.eightyPercent) && (this.project.current_sum < this.project.finance_round.sum)
        },
        eightyPercent() {
            return this.project.finance_round.sum * 0.8
        },
        amount() {
            if (this.project.finance_round) {
                return this.glCreateCost(this.project.finance_round.sum, 'RUB', {minimumFractionDigits: 0})
            }
            return ''
        },
        percent() {
            if (this.project.finance_round) {
                return this.project.finance_round.fixed_interest_rate
            }
            return ''
        },
        startDate() {
            if (this.project.finance_round) {
                return new Date(this.project.finance_round.start_date).toLocaleDateString('ru-RU')
            }
            return ''
        },
        endDate() {
            if (this.project.finance_round) {
                return new Date(this.project.finance_round.end_date).toLocaleDateString('ru-RU')
            }
            return ''
        },
    },
    beforeDestroy() {
        if (this.timer) clearInterval(this.timer);
    },
    methods: {
        tick() {
            this.currentDate = new Date()
        },
        momentGetDuration(name) {
            if (this.dateLeftRF24) {
                const result = this.dateLeftRF24.get(name);
                return result.toString().length < 2 ? `0${result}` : result;
            }
        },
        handleFinishRound() {
            this.$modal.show('default-modal', {
                title: `Вы уверены что хотите завершить раунд финансирования?`,
                description: 'После завершения раунда инвестирование в заявку станет недоступным и вам необходимо будет принять решение по займу.',
                maxWidth: 620,
                content: {
                    component: () => import('~/components/common/DialogModalContent.vue'),
                    props: {
                        buttons: [
                            {
                                title: 'Да',
                                width: '200px',
                                handler: () => {
                                    this.$modal.hide('dialog');
                                    this.finishRound();
                                }
                            },
                            {
                                title: 'Нет',
                                width: '200px',
                                light: true,
                                role: '',
                                handler: () => this.$modal.hide('dialog')
                            }
                        ]
                    }
                }
            })
        },
        finishRound() {
            this.$axios.post(`/intellectual-property/application/finance-round-time/${this.project.id}`)
                .then(({ data }) => {
                    if (data && data.status === 'success') {
                        document.location.reload()
                    }
                });
        },
        extendRound() {
            this.$modal.show('default-modal', {
                title: `Продлить раунд?`,
                maxWidth: 620,
                content: {
                    component: () => import('~/components/common/DialogModalContent.vue'),
                    props: {
                        description: 'Продление раунда будет осуществлено на срок указанный ранее',
                        buttons: [{
                            title: 'Да',
                            width: '200px',
                            handler: () => {
                                this.$modal.hide('default-modal')
                                setTimeout(() => {
                                    this.extendRoundSms()
                                }, 500)
                            }
                        },{
                            title: 'Отменить',
                            light: true,
                            width: '200px',
                            handler: () => {
                                this.$modal.hide('default-modal')
                            }
                        }],
                    }
                }
            })
        },
        extendRoundSms() {
            this.$modal.show('sms-confirm', {
                title: 'Продлить раунд',
                getCode: this.getExtendCode,
                sendCode: this.sendExtendCode,
                name: 'smsConfirmExtendRound',
                width: 280
            })
        },
        async getExtendCode() {
            let res = await this.$axios.post('/intellectual-property/application/extend-sms-send');
            return res
        },

        async sendExtendCode(code) {
            const res = await this.$axios.post(`/intellectual-property/application/extend/${this.project.id}`, {
                code: code,
            }).then(() => {
                this.$router.push({
                    name: 'profile-my-orders'
                })

            }).catch(err => {
                this.$notify({
                    type: 'error',
                    title: 'Возникла непредвиденная ошибка'
                })
            })

            return res
        },
        async handleSignContract() {
            this.signContract().catch(({ response }) => {
                const { data } = response
                if (data.error === 'request_limit_exceeded') {
                    this.$notify({
                        type: 'error',
                        title: 'Смс-код уже выслан и действителен в течении 10 минут'
                    })
                }
            }).finally(() => {
                this.$modal.show('default-modal', {
                    title: 'Ознакомиться с документами',
                    description: 'Ниже приведены договор залога и договоры займа. Пожалуйста ознакомтесь перед получением средств.',
                    maxWidth: 620,
                    content: {
                        component: () => import('~/components/project/modals/ProjectSignContractModal.vue'),
                        props: {
                            project: this.project,
                            signContractModal: this.signContractModal
                        }
                    }
                })
            })
        },
        signContractModal() {
            this.$modal.hide('default-modal')
            this.$modal.show('sms-confirm', {
                title: 'Получить займ',
                description: 'Нажимая кнопку "Подтвердить", Вы даете согласие на получение заемных денежных средств, а раунд финансирования будет успешно завершен.<br><br> Для подтверждения действия, <br>введите код из СМС-сообщения.',
                sendCode: this.sendCode,
                getCode: this.signContract,
                name: 'smsConfirmSignContract',
                disableAutoGet: true,
                width: 280
            })
        },
        async signContract() {
            const res = this.$axios.post(`/intellectual-property/application/sign-contract`, {
                id: this.project.id
            })
            return res
        },
        async sendCode(code) {
            const res = await this.$axios.post(`/intellectual-property/application/sign-contract/verify`, {
                id: this.project.id,
                code: code
            }).then(res => {
                this.$modal.hide('sms-confirm')
                this.$modal.hide('default-modal')
                this.$router.push({
                    name: 'profile-my-orders'
                })
            }).catch(err => {
                if (err.response.data.errors.finance_round) {
                    this.$notify({
                        type: 'error',
                        title: err.response.data.errors.finance_round
                    })
                }
                if (err.response.data.errors.finance_round_sum) {
                    this.$notify({
                        type: 'error',
                        title: err.response.data.errors.finance_round_sum
                    })
                }
                if (err.response.data.errors.code) {
                    this.$notify({
                        type: 'error',
                        title: err.response.data.errors.code
                    })   
                }
            })
            return res
        },
    },
    components: {
        VFormGroup,
        VButton
    }
}
